// extracted by mini-css-extract-plugin
export var bookList = "lists-module--bookList--e8730";
export var genericList = "lists-module--genericList--59455";
export var notFoundList = "lists-module--notFoundList--0dbec";
export var tocList = "lists-module--tocList--044e6";